import {  useAtom, useAtomValue, useSetAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const selectedCurrencyAtom = atomWithStorage(
	"obana_display_currency",
	"NGN"
);

export const useSelectedCurrency = () => useAtomValue(selectedCurrencyAtom);
export const useSetSelectedCurrency = () => useSetAtom(selectedCurrencyAtom);
export const useSelectedCurrencyState = () => useAtom(selectedCurrencyAtom);
